import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../../components/buttons/Button';
import type { MetagameBingoEvent } from '../../../../../../stores/bingo/types';
import { useStores } from '../../../../../../stores/useStores';
import { useBingoWidgetCallbacks } from '../../../../hooks';
import { BingoWidgetLogo } from '../../BingoWidgetLogo/BingoWidgetLogo';
import { BingoWideWidgetWrapper } from '../BingoWideWidgetWrapper/BingoWideWidgetWrapper';

import styles from './BingoStartingSoonWideWidget.module.scss';

interface BingoStartingSoonWideWidgetProps {
  event: MetagameBingoEvent;
}

export const BingoStartingSoonWideWidget = observer(function BingoStartingSoonWideWidget(
  props: BingoStartingSoonWideWidgetProps,
) {
  const { event } = props;
  const { t } = useTranslation();
  const { onPurchaseClick } = useBingoWidgetCallbacks();
  const { bingoStore } = useStores();
  const upcomingMatch = bingoStore.upcomingEvents?.find((e) => e.id === event.id);
  const isFreeDaub = event?.game?.isFreeDaubEvent ?? upcomingMatch?.game?.isFreeDaubEvent;
  const feature = isFreeDaub ? 'daub' : 'general';
  const bingoType = event?.coinType === 'GC' ? 'CASUAL' : 'SWEEP';

  return (
    <BingoWideWidgetWrapper
      dataTestId="bingo-starting-soon-wide-widget"
      feature={feature}
      wrapperClassName={styles.wrapper}
      onClick={onPurchaseClick}
    >
      <BingoWidgetLogo bingoType={bingoType} sizeType="wide" />
      <div className={styles.content}>
        <div className={styles.topWrapper}>
          <span className={classNames(styles.text, bingoType === 'SWEEP' ? styles.textSweep : styles.textCasual)}>
            {t('prime.lobbyBanner.startingSoonSm')}
          </span>
        </div>
        <div className={styles.btnWrapper}>
          <Button className={styles.btn} dataTestId="bingo-starting-soon-wide-widget-btn">
            {t('prime.lobbyBanner.purchase')}
          </Button>
        </div>
      </div>
    </BingoWideWidgetWrapper>
  );
});
